import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './SearchButton.styles';
const SearchButton = ({ children, fillDirection = 'right', icon, selected, ...otherProps }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { ...otherProps, "data-button-selected": selected, "data-fill": fillDirection },
            React.createElement(S.Text, null, children),
            React.createElement(S.IconWrapper, null, icon))));
};
export default SearchButton;
